// modules
import { MouseEvent } from "react";
import { animateScroll as scroll } from "react-scroll/modules";
import { NavigateFunction } from "react-router/dist/lib/hooks";

export const handleNavigation = (
  navigate: NavigateFunction,
  path: string,
): void => {
  const options = {
    duration: 200,
    smooth: true,
  };
  scroll.scrollToTop(options);
  setTimeout(() => navigate(path), 300);
};

export const handleLinkClick = (
  event: MouseEvent<HTMLAnchorElement>,
  navigate: NavigateFunction,
  path: string,
): void => {
  // keep "open in a new tab" working
  if (event.metaKey || event.ctrlKey || event.shiftKey) return;
  event.preventDefault();
  handleNavigation(navigate, path);
};
